import type { RouteRecordRaw } from 'vue-router'
import Password from '@/views/middleGround/my/password.vue'
import Subscribe from '@/views/middleGround/my/subscribe.vue'
import Information from '@/views/middleGround/my/information.vue'
import News from '@/views/middleGround/my/news.vue'
import Notices from '@/views/middleGround/my/notices.vue'
import Apply from '@/views/middleGround/my/apply.vue'

// 个人中心
export const MyRoute: Array<RouteRecordRaw> = [
  {
    path: 'my/password',
    name: 'Password',
    meta: {
      title: '个人中心-改密码' 
    },
    component: Password
  },
  {
    path: 'my/subscribe',
    name: 'Subscribe',
    meta: {
      title: '个人中心-我订阅的' 
    },
    component: Subscribe
  },
  {
    path: 'my/information',
    name: 'Information',
    meta: {
      title: '个人中心-个人资料' 
    },
    component: Information
  },
  {
    path: 'my/news',
    name: 'News',
    meta: {
      title: '个人中心-我的消息' 
    },
    component: News
  },
  {
    path: 'my/notices',
    name: 'Notices',
    meta: {
      title: '个人中心-站内信' 
    },
    component: Notices
  },
  {
    path: 'my/apply',
    name: 'Apply',
    meta: {
      title: '个人中心-我的报名' 
    },
    component: Apply
  }
]

export default MyRoute